import { schema } from 'normalizr';

export const ENTITY_VOICE_SETTINGS = 'voiceSettings';
export const VOICE_SETTINGS_ID_ATTRIBUTE = 'data';

export const voiceSettingsSchema = new schema.Entity(
  ENTITY_VOICE_SETTINGS,
  {},
  { idAttribute: () => VOICE_SETTINGS_ID_ATTRIBUTE },
);
